<template>
  <div class="menu-list">
       <div class="animated fadeIn">
        <b-row>
          <b-col cols="12">
            <div class="form-group row header-custom-switch">
              <div class="col-sm-10 col-form-label uppercase">
                <strong>
                  <h3>
                    <router-link :to="{ name: 'tradezone_list', params: { uuid: this.uuid }}" class="float-left mr-1 main-link">
                    {{ $t('store.tradezone_list') }} 
                    </router-link>
                    / 
                    {{ $t('store.subtradezone') }}
                  </h3>
                </strong>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
            <b-card
                header-tag="header"
                footer-tag="footer">
                <div slot="header">
                <i className="fa fa-align-justify"></i>
                <strong class="uppercase">{{ $t('store.subtradezone') }}</strong>
                </div>
                <b-col cols="12" class="text-center">

                <div class="table-responsive outlet-data">
                    <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                    <tr>
                        <th scope="col" :class="item.sort?'pointer':''" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)">
                        <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                        <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                        <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                        </th>
                        <th scope="col" style="min-width: 175px">{{$t('store.subtradezone_edit')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="dataTable.items.length == 0">
                        <td class="text-center" :colspan="dataTable.fields.length + 2">
                        {{$t('message.no_data')}}
                        </td>
                    </tr>
                    <tr v-for="item in dataTable.items" :key="item.id">
                        <td scope="row" class="text-center" v-for="field in dataTable.fields" :key="field.id">
                          <a v-if="field.render != null && field.name == 'is_wellformed' && item[field.name] == 0" style='color:#ef2929; font-size: 16px;' href="https://dev.mysql.com/doc/refman/5.7/en/geometry-well-formedness-validity.html" target="_blank" >
                              <i class="fa fa-exclamation-circle"></i>&nbsp;<span style="font-size: 14px;">{{$t('store.non_wellformed_learn_more')}}</span>
                          </a>
                          <span v-if="field.render != null && field.name == 'is_wellformed' && item[field.name] == 1" style='color:#20c520; font-size: 16px;' >
                              <i class="fa fa-check"></i>
                          </span>
                          <span v-if="field.render != null && field.name != 'subtradezone_map'  && field.name != 'is_wellformed'">{{item[field.name]}}</span>
                          <span v-if="field.render != null && field.name == 'subtradezone_opening'">{{item['business_hours']['opening']}}</span>
                          <span v-if="field.render != null && field.name == 'subtradezone_closing'">{{item['business_hours']['closing']}}</span>
                          <span v-if="field.render != null && field.name == 'subtradezone_delivery_time'">{{item['delivery_time']}}</span>
                          <span v-if="field.render != null && field.name == 'subtradezone_delivery_fee'">{{item['delivery_fee']}}</span>
                          <span v-if="field.render != null && field.name == 'subtradezone_map'">
                          <b-button size="sm" :class="'draw-map'" @click="openMap(item)" :variant="'primary'">
                              <strong>{{$t('store.view_tradezone_map')}}</strong>
                          </b-button>
                          </span>
                          <span v-if="field.render == null">
                              {{item[field.name]}}
                          </span>
                        </td>
                        <td scope="row">
                        <b-button size="sm" variant="primary" v-on:click="editItem(item['id'])">
                            <i class="fa fa-edit"></i> {{$t('common.edit')}}
                        </b-button>
                        <b-col cols="2" class="text-right remove-section" >
                            <i class="fa fa-trash-o text-main pointer" @click="removeSubTradezone(item['id'])" ></i>
                        </b-col>
                        </td>
                    </tr>
                    </tbody>
                    </table>
                </div>
                <b-row>
                    <b-col>
                    <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                    </b-col>
                    <b-col class="text-left">
                    {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                    </b-col>
                    <b-col col lg="1">
                    <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                    </b-col>
                </b-row>
                </b-col>
            </b-card>
            </b-col>
        </b-row>
       </div>
        <!-- New Map -->
        <b-modal ref="newMap" v-bind:title="$t('store.draw_map')" size="lg" body-class="padding-none" :hide-header="false"
                :hide-footer="true">
         <outlet-map v-bind:lat="outlet_map.lat" v-bind:long="outlet_map.long" v-bind:markers="markers" @paths="paths = $event"
                  v-bind:getpaths="paths"></outlet-map>
        </b-modal>

        <!-- Notification for add address -->
        <b-modal ref="notiMap" v-bind:title="$t('store.noti_draw_map')" size="lg">
        {{$t('store.noti_draw_map')}}
        </b-modal>
        <!--  -->
        <!-- End New map -->
  </div>
</template>

<script>
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import axios from 'axios'
import cSwitch from '../../../components/Switch'
import OutletMap from '../outlets/OutletsMap.vue'

const CancelToken = axios.CancelToken
let cancel = null
let vm = null
export default {
  name: 'SubTradezoneList',
  components: {
    DateRangePicker,
    cSwitch,
    DataTable,
    OutletMap
  },
  data: function () {
    return {
      outlet_config: {},
      type: 'like',
      statuses: [],
      filter: {
        options: [],
        selected: null,
        status: 1,
        field: null,
        key: null,
      },
      outlet_map: {
        long: 0,
        lat: 0,
      },
    
      outlet_id: 0,
      uuid: '',
      tradezone_id: 0,
      paths: [],
      markers: [{
        position: {lat: 0, lng: 0},
        label: '',
        draggable: false,
        title: ''
      }],
      dataTable: {
        items: [],
        fields: [
          {
            name: 'subtradezone_name',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
           {
            name: 'subtradezone_opening',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'subtradezone_closing',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
                {
            name: 'subtradezone_delivery_time',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'subtradezone_delivery_fee',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'is_wellformed',
            filter: false,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          },
          {
            name: 'subtradezone_map',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data
            }
          }
        ],
        sort: {
          field: 'updated_at',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },

    }
  },
 
  methods: {
    updateSort: function (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },

     openMap: function (item) {
        if (item.lat !== null && item.long !== null) {
            var position = {lat: item.lat, lng: item.long}
            vm.outlet_map.lat = item.lat;
            vm.outlet_map.long = item.long;
            vm.paths = [{id: item.id, coords: item.coords || []}]
            vm.markers.push({position: position, label: '', draggable: false, title: ''})
            this.$refs.newMap.show()
            this.$root.$emit('bv::show::modal')
           
        } else {
          this.$refs.notiMap.show()
        }
      },
      removeSubTradezone: function(subTradezoneId) {
        let options = {
          html: true,
          okText: vm.$t('common.delete'),
          cancelText: vm.$t('common.cancel')
        }
        vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
          .then(function (dialog) {
              vm.axios.outlet.deleteSubTradezone(subTradezoneId, function (response) {
                  vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                  vm.$bus.$emit('loading', 'none')
                  vm.refreshData();
              }, function () {
                  vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
                  vm.$bus.$emit('loading', 'none')
              })
          })
          .catch(function () {
          
          })
    },
    /**
     * Refesh data
    */
    refreshData: function () {
      let tradezoneId = this.$route.params.id;
      
      if (cancel != null) {
        cancel()
      }
      let search = ''
      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        search = "&"+ this.filter.field + "=" + this.filter.key.trim()
      }

      if (this.filter.status != '') {
        search = search + "&active=" + this.filter.status;
      }

      let params = "?limit="+this.dataTable.perPage+"&page=" +this.dataTable.currentPage+"&sort_by="+this.dataTable.sort.field+"&order_by="+this.dataTable.sort.type+ search;

      this.axios.outlet.getSubTradezoneList(tradezoneId, params,{
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          })
        },
        function(response){
          let langs = Object.keys(vm.$i18n.messages)
          let items = response.data.data.items;
          for (let l in langs) {
            vm.dataTable.items = response.data.data.items
            vm.dataTable.total = response.data.data.pagination.total
          }
          if(items.length > 0){
            vm.uuid = items[0].uuid;
            vm.outlet_id = items[0].outlet_id;
          }
        },
        function (error) {
          //your code
        });
    },

    /**
     * Link for edit Sub Tradezone
    */

    editItem: function (subTradezoneId) {
      this.$router.push({name: 'subtradezones_edit', params: { id: subTradezoneId }})
    },
    
  },
  created: function () {
    this.outlet_config = this.$store.getters.config.gms.outlet
    this.debouncedInput = _.debounce(this.refreshData, 240)
    vm = this
    let CancelToken = vm.axios.CancelToken
    this.dataTable.source = CancelToken.source()
    let dataFields = []
    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].name != 'address') {
        dataFields.push(this.dataTable.fields[i])
      } else {
        if (this.outlet_config.config && this.outlet_config.config.show_address_on_list !== false) {
          dataFields.push(this.dataTable.fields[i])
        }
      }
    }

    this.dataTable.fields = dataFields
    for (let i in this.dataTable.fields) {
      if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true) {
        this.filter.options.push(this.dataTable.fields[i])
      }
      if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
        this.dataTable.sort = {
          field: this.dataTable.fields[i].name,
          type: 'asc'
        }
      }
    }

    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'filter.key': function (val) {
      this.debouncedInput()
    },
    'dataTable.currentPage': function (val) {
      this.refreshData()
    },
    'dataTable.perPage': function (val) {
      this.refreshData()
    },
    'filter.status': function (val) {
      this.refreshData()
    },
    'filter.code': function (val) {
      this.refreshData()
    },
  }
}
</script>
<style scoped>
  .draw-map,
  .btn-primary {
    background: #0086FF !important;
    border-color: #0086FF !important;
    border-radius: 3px;
  }
  .btn-back {
    background-color: #0091ff;
    padding: 7px;
    margin-top: 3px;
  }
  
  .remove-section{
    display: inline-block;
    cursor: pointer;
  }
  .remove-section > .text-main{
    font-size: 20px;
  }

  table button {
    border-radius: 4px;
  }
  .table thead th:nth-child(2){
    width: 100px;
  }
  .table thead th:nth-child(3){
    width: 100px;
  }
  .table thead th:nth-child(4){
    width: 115px;
  }
  .table thead th:nth-child(5){
    width: 150px;
  }
  .table thead th:nth-child(6){
    width: 110px;
  }
  .table thead th:nth-child(8){
    width: 125px;
  }
  .table thead th:nth-child(9){
    width: 125px;
  }
  .table thead th:nth-child(10){
    width: 110px;
  }
  .table thead th:nth-child(1){
    width: 50px;
  }
  .table thead th:last-child{
    width: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/tradezone/ListSubTradezone.vue